import { useCreateInvoice, useFetchCreditsAvailable } from "@verde/entities";
import { PixIcon } from "@verde/icons";
import { Button, Checkbox, Skeleton } from "@verde/ui-core";
import React, { useCallback } from "react";
import { useCreditDialog } from "./credit-dialog";
import CreditBarDialogCreditItem from "./credit-dialog-credit-item";

function CreditDialogSelect() {
  const { selectedCredit, setSelectedInvoice, setKind, setSelectedCredit } =
    useCreditDialog();

  const create = useCreateInvoice();
  const { data, isLoading } = useFetchCreditsAvailable();

  const handleBuy = useCallback(async () => {
    if (!selectedCredit) return;

    const invoice = await create.mutateAsync({
      kind: "pix",
      value: selectedCredit?.value,
    });

    setKind("payment");
    setSelectedInvoice(invoice);
  }, [selectedCredit, create, setKind, setSelectedInvoice]);

  return (
    <div className="grid gap-4">
      <p className="text-lg font-semibold text-neutral-dark-2">
        Selecione quantos créditos quer carregar:
      </p>

      <div className="grid max-h-[200px] gap-2 overflow-y-auto rounded bg-neutral-light-1 p-4 scrollbar-thin">
        {isLoading && <Skeleton height={200} />}

        {!isLoading &&
          data?.map((item) => {
            const { credits, value } = item;

            return (
              <CreditBarDialogCreditItem
                key={`credit-item-${credits}`}
                prefix={
                  <Checkbox
                    id={`credit-item-${credits}`}
                    checked={selectedCredit?.credits === credits}
                    onChange={() => {
                      setSelectedCredit(
                        selectedCredit?.id === item.id ? undefined : item,
                      );
                    }}
                  />
                }
                title={`${credits} ${credits === 1 ? "crédito" : "créditos"}`}
                value={value}
              />
            );
          })}
      </div>

      <hr />

      <div className="grid gap-2">
        <CreditBarDialogCreditItem
          prefix={
            selectedCredit ? "Total selecionado:" : "Nenhum item selecionado"
          }
          title={
            selectedCredit
              ? `${selectedCredit?.credits} ${selectedCredit?.credits === 1 ? "crédito" : "créditos"}`
              : undefined
          }
          value={selectedCredit?.value ?? 0}
          selected
        />

        <Button
          size="lg"
          icon={<PixIcon />}
          disabled={!selectedCredit}
          onClick={handleBuy}
          loading={create.isLoading}
        >
          Comprar créditos (por pix)
        </Button>
      </div>
    </div>
  );
}

export default React.memo(CreditDialogSelect);
